import { makeStyles, Menu, MenuList, MenuPopover, MenuTrigger } from "@fluentui/react-components";
import { useState } from "react";
import DesktopSection from "./DesktopSection";
import MenuHeader from "./MenuHeader";
import INavigationSection from "../../../models/navigation/INavigationSection";
import INavigationArea from "../../../models/navigation/INavigationArea";

interface IDesktopAreaProps {
    area: INavigationArea;
}

const useStyles = makeStyles({
    serviceMenuList: {
        display: "grid",
        gap: "1rem",
    }
});

export default function DesktopArea(props: IDesktopAreaProps) {
    const { area } = props;
    const styles = useStyles();
    
    const [menuOpen, setMenuOpen] = useState(false);
    
    const columnCount = Math.min(area.sections.length, 3);
    const gridStyle = {
        gridTemplateColumns: `repeat(${columnCount}, 1fr)`
    };

    return (
        <Menu 
            positioning={{ autoSize: true }} 
            open={menuOpen}
            onOpenChange={(e, data) => setMenuOpen(data.open)}
        >
            <MenuTrigger disableButtonEnhancement>
                <div
                    onMouseEnter={() => setMenuOpen(true)}
                    onMouseLeave={() => setMenuOpen(false)}
                >
                    <MenuHeader label={area.name} />
                </div>
            </MenuTrigger>
            <MenuPopover
                onMouseEnter={() => setMenuOpen(true)}
                onMouseLeave={() => setMenuOpen(false)}
            >
                <MenuList className={styles.serviceMenuList} style={gridStyle}>
                    {
                        area.sections
                            .sort((a, b) => a.order - b.order)
                            .map((section: INavigationSection) => (
                                <DesktopSection key={section.id} area={area} section={section} />
                            ))
                    }
                </MenuList>
            </MenuPopover>
        </Menu>
    );
}